(function () {
  'use strict';

  if (window.__ulSeoEventsLoaded) return;
  window.__ulSeoEventsLoaded = true;

  var trackedExternalOrigins = ['www.unlimitedlights.com', 'unlimitedlights.com'];

  function pushEvent(eventName, parameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      source_url: window.location.href
    }, parameters || {}));
  }

  function getAnchor(node) {
    while (node && node !== document) {
      if (node.tagName && node.tagName.toLowerCase() === 'a') return node;
      node = node.parentNode;
    }
    return null;
  }

  function normalizeUrl(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isInternal(url) {
    return url && (url.origin === window.location.origin || trackedExternalOrigins.indexOf(url.hostname) !== -1);
  }

  function cleanText(anchor) {
    return (anchor.textContent || anchor.getAttribute('aria-label') || anchor.title || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function closestWithAttribute(node, attributeName) {
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute(attributeName)) return node;
      node = node.parentNode;
    }
    return null;
  }

  function isSpecDownload(url) {
    var pathname = (url.pathname || '').toLowerCase();
    var href = url.href.toLowerCase();
    return /\.(pdf|ies|ldt|doc|docx|xls|xlsx)(\?|$)/.test(pathname) || /(spec|cut[-_ ]?sheet|install|installation|ies|photometric)/.test(href);
  }

  function shouldTrackSeoCta(sourcePath, targetPath) {
    var sourceIsContent = sourcePath.indexOf('/pages/learning-center') === 0
      || sourcePath.indexOf('/pages/learning-center') === 0
      || sourcePath.indexOf('/lighting-guide') === 0
      || sourcePath.indexOf('/pages/') === 0;
    var targetIsMoney = targetPath.indexOf('/collections/') === 0 || targetPath.indexOf('/products/') === 0;
    return sourceIsContent && targetIsMoney;
  }

  function getContentGroup(sourcePath) {
    if (sourcePath.indexOf('/pages/learning-center') === 0 || sourcePath.indexOf('/lighting-guide') === 0) {
      return 'lighting_guide';
    }

    if (sourcePath.indexOf('/pages/learning-center') === 0) {
      return 'egress_knowledge_hub';
    }

    return 'compliance_page';
  }

  function pushToolEvent(action, toolCard, targetUrl, targetPath, linkText) {
    var eventMap = {
      start: 'tool_start',
      complete: 'tool_complete',
      recommendation: 'tool_recommendation_click',
      quote_handoff: 'tool_quote_handoff'
    };

    var eventName = eventMap[action];
    if (!eventName || !toolCard) return;

    pushEvent(eventName, {
      tool_name: toolCard.getAttribute('data-ul-tool-name') || '',
      tool_label: toolCard.getAttribute('data-ul-tool-label') || '',
      target_url: targetUrl,
      target_path: targetPath,
      link_text: linkText
    });
  }

  document.addEventListener('click', function (event) {
    var anchor = getAnchor(event.target);
    if (!anchor) return;

    var url = normalizeUrl(anchor.getAttribute('href') || '');
    if (!url) return;

    var linkText = cleanText(anchor);
    var targetUrl = url.href;
    var targetPath = url.pathname;
    var toolCard = closestWithAttribute(anchor, 'data-ul-tool-name');
    var toolAction = anchor.getAttribute('data-ul-tool-action') || '';

    pushToolEvent(toolAction, toolCard, targetUrl, targetPath, linkText);

    if (isInternal(url) && shouldTrackSeoCta(window.location.pathname, targetPath)) {
      pushEvent('seo_internal_cta_click', {
        target_url: targetUrl,
        target_path: targetPath,
        link_text: linkText,
        content_group: getContentGroup(window.location.pathname)
      });
    }

    if (isSpecDownload(url)) {
      pushEvent('spec_sheet_download', {
        file_url: targetUrl,
        file_type: (targetPath.split('.').pop() || '').split('?')[0],
        link_text: linkText
      });
    }

    if (targetPath.indexOf('/pages/request-a-quote') === 0 || targetPath.indexOf('/apps/request-a-quote') === 0 || url.protocol === 'tel:') {
      var quoteParameters = {
        target_url: targetUrl,
        link_text: linkText,
        phone_number: url.protocol === 'tel:' ? anchor.getAttribute('href').replace(/^tel:/, '') : ''
      };

      if (toolCard && toolAction === 'quote_handoff') {
        quoteParameters.tool_name = toolCard.getAttribute('data-ul-tool-name') || '';
        quoteParameters.tool_label = toolCard.getAttribute('data-ul-tool-label') || '';
      }

      pushEvent('quote_click', quoteParameters);
    }

    if (targetPath.indexOf('/checkout') === 0 || /checkout/i.test(linkText)) {
      pushEvent('begin_checkout', {
        target_url: targetUrl,
        link_text: linkText
      });
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;

    var action = normalizeUrl(form.getAttribute('action') || '');
    if (action && action.pathname.indexOf('/cart/add') === 0) {
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      pushEvent('add_to_cart', {
        item_id: variantInput ? variantInput.value : '',
        quantity: quantityInput ? quantityInput.value : '1'
      });
    }

    if (action && action.pathname.indexOf('/cart') === 0 && /checkout/i.test(form.outerHTML || '')) {
      pushEvent('begin_checkout', {
        target_url: action.href
      });
    }
  }, true);
})();
